export default {
  title: 'Importare meniu',
  master_title: 'Mod brand - Import meniu',
  buttons: {
    import: 'Import',
  },
  toasts: {
    import: {
      pending:
        '⏳Deoarece importul poate fi uneori lent, îl efectuăm în fundal. Verificați meniul restaurantului în câteva minute.',
    },
  },
};
